var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Component_1 = require("../Component");
var Spinner_1 = require("../react-component/Spinner");
var URLS_1 = require("../../common/constants/URLS");
function DynamicHOC(widgetPath, defaultProps) {
    return _a = (function (_super) {
            __extends(DynamicHOCWrapper, _super);
            function DynamicHOCWrapper(props) {
                var _this = _super.call(this, props) || this;
                _this.getImports = function (path) {
                    var module;
                    switch (path) {
                        case URLS_1.default.BIKE_LANDING:
                            module = Promise.resolve().then(function () { return require('../../bike-product/bike-qf.cfwidget'); });
                            break;
                        case URLS_1.default.BIKE_PROPOSAL:
                            module = Promise.resolve().then(function () { return require('../../bike-product/components/bike-pf.cfwidget'); });
                            break;
                        case URLS_1.default.BIKE_RESULTS:
                            module = Promise.resolve().then(function () { return require('../../bike-product/components/bike-rp.cfwidget'); });
                            break;
                        case URLS_1.default.CAR_LANDING:
                            module = Promise.resolve().then(function () { return require('../../motor-product/car-new.cfwidget'); });
                            break;
                        case URLS_1.default.TRAVEL_SINGLETRIP:
                            module = Promise.resolve().then(function () { return require('../../travel-product/travel-st.cfwidget'); });
                            break;
                        case URLS_1.default.TRAVEL_MULTITRIP:
                            module = Promise.resolve().then(function () { return require('../../travel-product/travel-mt.cfwidget'); });
                            break;
                        case URLS_1.default.HEALTH_INDEMNITY:
                            module = Promise.resolve().then(function () { return require('../../new-health-product/health-im.cfwidget'); });
                            break;
                        case URLS_1.default.HEALTH_SUPERTOPUP:
                            module = Promise.resolve().then(function () { return require('../../new-health-product/health-st.cfwidget'); });
                            break;
                        case URLS_1.default.LIFE_LANDING:
                            module = Promise.resolve().then(function () { return require('../../life-product/life-qf.cfwidget'); });
                            break;
                        case URLS_1.default.LIFE_PROPOSAL:
                            module = Promise.resolve().then(function () { return require('../../life-product/life-pf.cfwidget'); });
                            break;
                        case URLS_1.default.LIFE_RESULTS:
                            module = Promise.resolve().then(function () { return require('../../life-product/life-rp.cfwidget'); });
                            break;
                        case URLS_1.default.LIFE_PLANQUOTE:
                            module = Promise.resolve().then(function () { return require('../../life-product/life-rp.cfwidget'); });
                            break;
                        case URLS_1.default.ULIP_LANDING:
                            module = Promise.resolve().then(function () { return require('../../ulip-product/ulip-qf.cfwidget'); });
                            break;
                        case URLS_1.default.ULIP_RESULTS:
                            module = Promise.resolve().then(function () { return require('../../ulip-product/ulip-rp.cfwidget'); });
                            break;
                        case URLS_1.default.TAXI_LANDING:
                            module = Promise.resolve().then(function () { return require('../../motor-product/commercial-car.cfwidget'); });
                            break;
                        default:
                            module = Promise.resolve().then(function () { return require('../../bike-product/bike-qf.cfwidget'); });
                    }
                    return module;
                };
                _this.state = {
                    ComponentClass: null,
                };
                return _this;
            }
            DynamicHOCWrapper.prototype.componentDidMount = function () {
                var _this = this;
                this.mounted = true;
                this.getImports(widgetPath).then(function (modulecallback) {
                    modulecallback(function (data) {
                        var value = data.default;
                        _this.setState({ ComponentClass: value });
                    });
                });
            };
            DynamicHOCWrapper.prototype.componentWillUnmount = function () {
                this.mounted = false;
            };
            DynamicHOCWrapper.prototype.render = function () {
                var ComponentClass = this.state.ComponentClass;
                return ComponentClass ? React.createElement(ComponentClass, __assign({}, this.props)) : React.createElement(Spinner_1.default, null);
            };
            return DynamicHOCWrapper;
        }(Component_1.default)),
        _a.defaultProps = defaultProps,
        _a;
    var _a;
}
exports.DynamicHOC = DynamicHOC;
